import React, { useEffect, useState, useCallback } from 'react';
import _ from 'underscore';
import PropTypes from 'prop-types';
import { BudgetSuggestionContainer } from './components/budget-suggestion-container';
import { BudgetSuggestionOfflineContainer } from './components/budget-suggestion-offline-container';
import { useBudgetSuggestionRepository } from './use-budget-suggestion-repository';
import { MODE, CustomBudget } from './model/constants';

export const BudgetSuggestion = ({
  mode,
  campaignId,
  campaign,
  assetGroup,
  campaignType,
  currency,
  onBudgetValidate,
  bidType,
  ...rest
}) => {
  const { loadBudget, fetchCustomBudgetPerformanceData } = useBudgetSuggestionRepository({
    mode,
    campaignId,
    campaignType,
    currency,
    campaign,
    assetGroup,
  });

  const [isLoading, setIsLoading] = useState(true);

  const [budgetSuggestionData, setBudgetSuggestionData] = useState(null);

  const [customPerformanceData, setCustomPerformanceData] = useState(null);

  useEffect(() => {
    setIsLoading(true);
    loadBudget().then((data) => {
      setBudgetSuggestionData(data);
    }).finally(() => {
      setIsLoading(false);
    });
  }, [loadBudget]);

  const onBudgetSuggestionChange = useCallback((result) => {
    const { data } = result;

    const { budgetTier, budgetAmount } = data;

    if (budgetTier === CustomBudget) {
      setCustomPerformanceData({ isLoading: true });
      fetchCustomBudgetPerformanceData({ budgetAmount })
        .then((customBudgetResult) => {
          setCustomPerformanceData({ isLoading: false, ...customBudgetResult });
        })
        .catch((err) => {
          setCustomPerformanceData({ isLoading: false, err });
        });
    }
    onBudgetValidate(result);
  }, [fetchCustomBudgetPerformanceData, onBudgetValidate]);

  return (
    mode === MODE.CREATION ?
      <BudgetSuggestionContainer
        data={budgetSuggestionData}
        isLoading={isLoading}
        mode={mode}
        campaignType={campaignType}
        currency={currency}
        onBudgetValidate={onBudgetSuggestionChange}
        customPerformanceData={customPerformanceData}
        bidType={bidType}
        {...rest}
      />
      :
      <BudgetSuggestionOfflineContainer
        data={budgetSuggestionData}
        isLoading={isLoading}
        mode={mode}
        campaignType={campaignType}
        onBudgetValidate={onBudgetValidate}
        fetchCustomBudgetPerformanceData={fetchCustomBudgetPerformanceData}
        bidType={bidType}
        {...rest}
      />
  );
};

BudgetSuggestion.propTypes = {
  mode: PropTypes.string,
  campaignId: PropTypes.string,
  campaignType: PropTypes.string,
  currency: PropTypes.string,
  onBudgetValidate: PropTypes.func,
  campaign: PropTypes.shape({}),
  assetGroup: PropTypes.shape({}),
  bidType: PropTypes.string.isRequired,
};

BudgetSuggestion.defaultProps = {
  mode: MODE.EDITING,
  campaignId: undefined,
  campaignType: undefined,
  currency: undefined,
  onBudgetValidate: _.noop,
  campaign: undefined,
  assetGroup: undefined,
};
